import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, PropTypes } from 'react';
import { connect, ReactReduxContext, Provider } from 'react-redux';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { BigText, DataTable, Dotdotdot, PageHeader, Spinner, StackedStatBar } from 'components';
import FacebookPreview from '../../components/PostPlatformPreview/FacebookPreview';
import { getRecentFBPagePostStats, clearRecentFBPosts } from 'redux/modules/reporting';
import moment from 'moment';
import humanFormat from 'human-format';
import * as styles from './Reports.scss';
var numberFormatScale = new humanFormat.Scale({
  '': 1,
  k: 1000,
  M: 1000000,
  B: 1000000000,
  T: 1000000000000
});
var RecentFBPosts = (_dec = connect(function (state) {
  return {
    org: state.organization.current,
    recentFBPosts: state.reporting.recentFBPosts,
    loading: state.reporting.loadingRecentFBPosts,
    theme: state.theme,
    loadingMore: state.reporting.loadingMorePosts,
    paging: state.reporting.recentPostsPaging,
    recentFbPostsLoadingError: state.reporting.recentFbPostsLoadingError
  };
}, {
  getRecentFBPagePostStats: getRecentFBPagePostStats,
  clearRecentFBPosts: clearRecentFBPosts
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(RecentFBPosts, _Component);

  var _super = _createSuper(RecentFBPosts);

  function RecentFBPosts(props) {
    var _this;

    _classCallCheck(this, RecentFBPosts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearRecentFBPosts();
    });

    _defineProperty(_assertThisInitialized(_this), "loadMorePosts", function () {
      var org = _this.props.org;
      var fbPageAccount = org.SocialAccounts.find(function (sa) {
        return sa.platform === 'Facebook page';
      });

      _this.props.getRecentFBPagePostStats(org.id, fbPageAccount.id, _this.props.paging);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTypeIcon", function (post) {
      var mediaType = post.attachments && post.attachments.data && post.attachments.data.length > 0 ? post.attachments.data[0].media_type : 'status';
      var iconClass;

      switch (mediaType) {
        case 'photo':
          iconClass = 'ion-ios-photos';
          break;

        case 'status':
          iconClass = 'ion-chatbox';
          break;

        case 'video':
          iconClass = 'ion-ios-videocam';
          break;

        case 'link':
          iconClass = 'ion-link';
          break;

        default:
          iconClass = 'ion-document-text';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "icon ".concat(iconClass, " ").concat(styles.typeIcon)
      }));
    });

    _this.state = {
      showRowDetailModal: false,
      rowDetailModalData: null
    };
    return _this;
  }

  _createClass(RecentFBPosts, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var org = this.props.org;
      var fbPageAccount = org.SocialAccounts.find(function (sa) {
        return sa.platform === 'Facebook page';
      });

      if (fbPageAccount) {
        this.props.getRecentFBPagePostStats(org.id, fbPageAccount.id);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.org.id !== this.props.org.id) {
        this.props.clearRecentFBPosts();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var formattedData = this.props.recentFBPosts.map(function (d) {
        var img = d.picture;

        var organicReach = function () {
          try {
            return d.insights.data.find(function (i) {
              return i.name === 'post_impressions_organic_unique';
            }).values[0].value;
          } catch (e) {
            return 0;
          }
        }();

        var paidReach = function () {
          try {
            return d.insights.data.find(function (i) {
              return i.name === 'post_impressions_paid_unique';
            }).values[0].value;
          } catch (e) {
            return 0;
          }
        }();

        var totalReach = organicReach + paidReach;

        var clicks = function () {
          try {
            return d.insights.data.find(function (i) {
              return i.name === 'post_consumptions';
            }).values[0].value;
          } catch (e) {
            return 0;
          }
        }();

        var likes = d.likes ? d.likes.summary.total_count : 0;
        var shares = d.shares ? d.shares.count : 0;
        var comments = d.comments ? d.comments.summary.total_count : 0;
        var totalEngagement = likes + comments + shares + clicks;
        return {
          rawData: d,
          publishedAt: /*#__PURE__*/React.createElement("div", {
            className: "column"
          }, /*#__PURE__*/React.createElement("div", {
            className: "row",
            style: {
              margin: 0
            }
          }, moment(d.created_time).format('M/D/YYYY')), /*#__PURE__*/React.createElement("div", _defineProperty({
            className: "row",
            style: {
              margin: 0
            }
          }, "className", styles.timeSubtext), moment(d.created_time).format('h:mm A'))),
          post: /*#__PURE__*/React.createElement("div", {
            className: "row",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "column ".concat(styles.postImg),
            style: {
              backgroundImage: "url(".concat(img, ")")
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: "column ".concat(styles.wrappedParagraph)
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dotdotdot, {
            clamp: 2
          }, d.message)))),
          type: _this2.renderTypeIcon(d),
          engagement: /*#__PURE__*/React.createElement("div", {
            className: styles.engagementColumn
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.rowHeaderText
          }, humanFormat(totalEngagement, {
            scale: numberFormatScale
          })), /*#__PURE__*/React.createElement(StackedStatBar, {
            data: [{
              name: 'Clicks',
              value: humanFormat(clicks, {
                scale: numberFormatScale
              }) || 0,
              color: '#6891b5'
            }, {
              name: 'Likes',
              value: humanFormat(likes, {
                scale: numberFormatScale
              }) || 0,
              color: '#a95963'
            }, {
              name: 'Comments',
              value: humanFormat(comments, {
                scale: numberFormatScale
              }) || 0,
              color: '#89a0b5'
            }, {
              name: 'Shares',
              value: humanFormat(shares, {
                scale: numberFormatScale
              }) || 0,
              color: '#a8747a'
            }]
          })),
          likes: likes,
          comments: comments,
          shares: shares,
          clicks: clicks,
          totalReach: totalReach,
          reach: /*#__PURE__*/React.createElement("div", {
            style: {
              alignItems: 'center',
              margin: 0,
              width: '300px'
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.rowHeaderText
          }, humanFormat(totalReach, {
            scale: numberFormatScale
          }) || 0), /*#__PURE__*/React.createElement(StackedStatBar, {
            data: [{
              name: 'Organic Reach',
              value: humanFormat(organicReach, {
                scale: numberFormatScale
              }) || 0,
              color: '#e4a27a'
            }, {
              name: 'Paid Reach',
              value: humanFormat(paidReach, {
                scale: numberFormatScale
              }) || 0,
              color: '#eb7434'
            }]
          }))
        };
      });
      var headerFields = [{
        name: 'PUBLISHED',
        key: 'publishedAt'
      }, {
        name: 'POST',
        key: 'post'
      }, {
        name: 'TYPE',
        key: 'type'
      }, {
        name: 'REACH',
        key: 'reach'
      }, {
        name: 'ENGAGEMENT',
        key: 'engagement'
      }];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Reports - Recent Facebook Posts"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Reports",
        secondary: "Recent Posts"
      }), this.props.recentFbPostsLoadingError ? /*#__PURE__*/React.createElement("p", null, "Failed to load your recent Facebook posts.") : this.props.recentFBPosts.length ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DataTable, {
        noRowClasses: true,
        headerFields: headerFields,
        displaySearch: false,
        onRowSelection: function onRowSelection(data) {
          _this2.setState({
            rowDetailModalData: data
          }, function () {
            // load image before showing Dialog, so height is correct
            var image = new Image();
            image.src = data.rawData.full_picture;

            image.onload = function () {
              _this2.setState({
                showRowDetailModal: true
              });
            };
          });
        },
        data: formattedData,
        loading: this.props.loading,
        style: {
          width: '100%'
        },
        hideSort: true
      })), this.props.loadingMore ? /*#__PURE__*/React.createElement("div", {
        style: {
          minHeight: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : /*#__PURE__*/React.createElement("div", {
        onClick: this.loadMorePosts,
        style: {
          color: this.props.theme.colors.gray1,
          cursor: 'pointer',
          fontFamily: 'Oswald',
          marginBottom: 20,
          paddingTop: 35,
          textAlign: 'center',
          textTransform: 'uppercase'
        }
      }, this.props.recentFBPosts.length && this.props.paging && this.props.paging.after ? 'Load More Posts' : '')) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }), this.props.loading && /*#__PURE__*/React.createElement("div", {
        style: {
          minHeight: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          bodyStyle: {
            padding: 0
          },
          contentStyle: {
            width: '85%',
            maxWidth: 1500
          },
          autoScrollBodyContent: true,
          title: "Post Details",
          open: _this2.state.showRowDetailModal,
          onRequestClose: function onRequestClose() {
            _this2.setState({
              showRowDetailModal: false,
              rowDetailModalData: null
            });
          },
          actions: [/*#__PURE__*/React.createElement(RaisedButton, {
            label: "Close",
            onClick: function onClick() {
              _this2.setState({
                showRowDetailModal: false,
                rowDetailModalData: null
              });
            },
            style: {
              marginRight: 24
            }
          })]
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, _this2.state.rowDetailModalData ? /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: '1 1 45%',
            borderRight: '1px solid #dfdfdf',
            padding: '2%'
          }
        }, /*#__PURE__*/React.createElement(FacebookPreview, {
          postType: "imagePost",
          images: _this2.state.rowDetailModalData.rawData.full_picture ? [_this2.state.rowDetailModalData.rawData.full_picture] : [],
          message: _this2.state.rowDetailModalData.rawData.message,
          postDate: moment(_this2.state.rowDetailModalData.rawData.created_time)
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: '1 1 45%'
          }
        }, /*#__PURE__*/React.createElement(BigText, {
          number: _this2.state.rowDetailModalData.clicks,
          text: "Clicks"
        }), /*#__PURE__*/React.createElement(BigText, {
          number: _this2.state.rowDetailModalData.comments,
          text: "Comments"
        }), /*#__PURE__*/React.createElement(BigText, {
          number: _this2.state.rowDetailModalData.likes,
          text: "Likes"
        }), /*#__PURE__*/React.createElement(BigText, {
          number: _this2.state.rowDetailModalData.shares,
          text: "Shares"
        }), /*#__PURE__*/React.createElement(BigText, {
          number: _this2.state.rowDetailModalData.totalReach,
          text: "Reach"
        }))) : null));
      }));
    }
  }]);

  return RecentFBPosts;
}(Component)) || _class);
export { RecentFBPosts as default };